import { router } from '../utils/router';
export function routingTabsCreatedRouting(tabStr) {
    var _a;
    const data = router.query();
    const slugValue = data && data.slug ? (_a = data.slug) === null || _a === void 0 ? void 0 : _a[0] : '';
    const idString = data && data.idString ? data.idString : '';
    const newRoute = `/${idString}/${slugValue}/${tabStr}`;
    return [newRoute.toString(), undefined, { shallow: true }];
}
